// Status of a manual supplemental listing. `id` is the stored CF status code (Coming/Active/PEND/SOLD
// — cpropmodify_output_1.cfm:214-218) so it maps directly to the API's `status` field and the form's
// radio values. Modeled on src/type/off-market-status.ts.
class Type {

	public static COMING = new Type("Coming", "Coming Soon");
	public static ACTIVE = new Type("Active", "Active");
	public static PENDING = new Type("PEND", "Pending");
	public static SOLD = new Type("SOLD", "Sold");

	private constructor(
		public readonly id: "Coming" | "Active" | "PEND" | "SOLD",
		public readonly label: string,
	) {
	}

	public get sold() {
		return this === Type.SOLD;
	}

	public static values(): Type[] {
		return Object.values(Type);
	}

	public static getById(id: string) {
		return this.values().find(value => value.id === id);
	}

}

export { Type as SupplementalStatus };
